import classNames from 'classnames';
import React from 'react';
import { Counter, CounterSize, ImageLoadingBehaviorOptions, ImageResizeOptions as TPAImageResizeOptions, Text as TPAText, TextPriority, ThumbnailImage } from 'wix-ui-tpa/cssVars';
import { useConfig } from '../../contexts/config-context';
import { ImageResizeOptions } from '../../field-settings/settings-shared/image/types';
import { useTpaStyleParams } from '../shared/use-tpa-style-params';
import { classes, st } from './product.st.css';
const toTPAImageResize = {
  [ImageResizeOptions.crop]: TPAImageResizeOptions.cover,
  [ImageResizeOptions.fit]: TPAImageResizeOptions.contain
};
export const Product = _ref => {
  var _item$media;
  let {
    item,
    imageResize,
    onQuantityChange,
    price = 0,
    hasError,
    quantity = 0
  } = _ref;
  const {
    currency
  } = useConfig();
  const {
    isBorderStyleNone,
    isBorderStyleBottom
  } = useTpaStyleParams();
  function setQuantity(value) {
    onQuantityChange == null || onQuantityChange(value < 0 ? 0 : value);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: st(classes.root),
    "data-hook": "product"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.main
  }, (_item$media = item.media) != null && _item$media.image ? /*#__PURE__*/React.createElement("div", {
    className: classes.image
  }, /*#__PURE__*/React.createElement(ThumbnailImage, {
    aspectRatio: "square",
    height: 96,
    width: 96,
    loadingBehavior: ImageLoadingBehaviorOptions.blur,
    resize: toTPAImageResize[imageResize],
    sourceHeight: item.media.image.height,
    sourceWidth: item.media.image.width,
    src: item.media.image.id,
    stretchImage: true
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: classes.info
  }, /*#__PURE__*/React.createElement(TPAText, {
    "data-hook": "product-label",
    className: classes.productName,
    priority: item.label ? TextPriority.primary : TextPriority.secondary
  }, item.label || ''), /*#__PURE__*/React.createElement(TPAText, {
    "data-hook": "product-price",
    className: classes.productPrice,
    priority: price !== undefined ? TextPriority.primary : TextPriority.secondary
  }, applyCurrency(price, currency)))), onQuantityChange ? /*#__PURE__*/React.createElement(Counter, {
    "data-hook": "product-quantity",
    className: classNames(classes.counter, {
      [classes.line]: isBorderStyleBottom,
      [classes.noBorder]: isBorderStyleNone,
      [classes.error]: hasError
    }),
    incrementAriaLabel: "",
    decrementAriaLabel: "",
    inputAriaLabel: "",
    size: CounterSize.xSmall,
    step: 1,
    min: 0,
    value: quantity,
    onChange: val => {
      setQuantity(Number(val));
    },
    error: hasError,
    steppersType: "button"
  }) : null);
};
function applyCurrency(price, currency) {
  if (!currency) {
    return `${price}`;
  }
  if (currency.sign) {
    return `${currency.sign}${price}`;
  }
  if (currency.code) {
    return `${currency.code} ${price}`;
  }
  return `${price}`;
}
//# sourceMappingURL=product.js.map